import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

import classNames from 'classnames';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Link } from 'react-router-dom';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from '@material-ui/core/Typography';
import TablePagination from '@material-ui/core/TablePagination'
import Button from '@material-ui/core/Button'
import Popover from '@material-ui/core/Popover';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import { Box, Card, CardContent, Dialog, DialogContent, DialogTitle, Grid } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Screenshot from '../../../../../helpers/Screenshot';
import Elements from '../../BaseElementsPlus/ElementsPlus'
import Tooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
// Component styles
import styles from '../styles';
import { api_host , api_auth} from '../../../../../common/globals/constants';
//import spritesheet from '../../../../../icons/spritesheet-simbología.png';
import icons from '../../../../../theme/icons.js';
import { AtTimelineEvent } from '../../../../../components/AtTimeline/AtTimelineEvent';
import { lista_estados } from '../../../../../data/status_error_icons.js';
import { AtCircularProgress } from '../../../../../components/AtCircularProgress/index.jsx';
import { getQueryParams } from '../../../../../utils/fns/get-query-params.js';
import {getMonitorsList} from '../../../../../services/getMonitorsList'
import { withTranslation } from 'react-i18next';

const moment = require('moment');
class EventsTable extends Component {
    _currentObjectiveId = null;
    constructor(props) {
        super(props);  
        var intervalo = 0
        var objective = 0
        var nodos = []
        var pasos_criticos = {}
        if (typeof(props.location && props.location.state && props.location.state.fromObjective) != 'undefined'){
            intervalo = props.location.state.fromObjective.intervalo
            nodos = props.location.state.fromObjective.Nodos
            pasos_criticos = props.location.state.fromObjective.paso_critico
        } else {
            intervalo = props.interval
            nodos = props.nodesList
            pasos_criticos = props.critic_step
        }
        if(props.match.params.objetivo_id){
            objective = props.match.params.objetivo_id
        }else{
            objective = props.objective
        }
        this.state = {
            currentObjectiveId : objective,
            //service: props.location.state.fromObjective.grupo_servicio_unificado,
            nodes: nodos,
            loadObjectiveData : false,
            actualUptime: 0,
            externalData: null,
            dataError: false,
            isLoading: true,
            time: props.dates,
            totalCell: 2,
            StatePeriod: 'props.params.StatePeriod', 
            pages: 1,
            page: 0, 
            isOpen: false,
            target: null,
            currentMonitor: null,
            currentDate: null,
            dateBegin: 'fecha_inicio',
            dateEnd: 'fecha_termino',
            interval: intervalo ?? '-',
            graph: props.dates['y'],
            monitores: props.monitores,
            listScreenshot: [],
            modalOpen: false,
            modalOpenEle:false,
            dateBeginScreenshot: '',
            listPlus:[258,270,271,272],
            pasos_criticos: pasos_criticos
        }
    }
    static getDerivedStateFromProps(nextProps, prevState){
        /*-if (nextProps.match.params.objetivo_id !== prevState.prevObjectiveId) {
            return {
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                isLoading: true,
                dataError: false,
                statePeriod: nextProps.params.statePeriod
            }
        } else if (nextProps.params.period !== prevState.time) {
            return {
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                statePeriod: nextProps.params.statePeriod
            }
        } else if (nextProps.params.period === prevState.time && nextProps.params.statePeriod !== prevState.statePeriod) {
            return {
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: prevState.time,
                dataError: false,
                isLoading: true,
                statePeriod: nextProps.params.statePeriod,
            }
        }*/
        return null;
    }
    componentDidMount() {
        this.getDataFromAPI();
    }  

    componentDidUpdate(prevProps, prevState) {
        if (/*(prevProps.params.period !== this.state.time) ||*/
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id)/* ||
            (prevProps.params.statePeriod !== this.state.statePeriod)*/) {
            this.getDataFromAPI();
        }
    }

    getFetchs = (objective, begin, final, monitores, token) =>{
        return new Promise((resolve, reject) => {
            var cdnList = []
            var fetches = []            
            monitores.forEach((value, key)=>{
                var monitor_id=(value)
                var getListScreenshot = fetch(api_host+`/reporte/general/objetivos/${objective}/screenshots/list_images/?token=${token}&fecha_inicio=${begin}&fecha_termino=${final}&monitor=${monitor_id}`)
                        .then( response => response.json())
                fetches.push(                    
                    getListScreenshot.then( dataCdn =>  { 
                            cdnList[key] = dataCdn;
                    })                    
                )
            })
            Promise.all(fetches).then(() => {
                resolve(cdnList);
            })      
        });
    }



    getDataFromAPI = (objectiveId) => {
        
        const { time, statePeriod, currentObjectiveId, interval, monitores } = this.state
        let token = sessionStorage.getItem('key')
        let id_user = sessionStorage.getItem('user')
        var begin = new Date(time['x'])
        var end = new Date(time['x2']) 
        let beginTitle = begin.toISOString().substring(0, 19).replace('T', ' ')
        let endTitle = end.toISOString().substring(0, 19).replace('T', ' ')         
            
        if (interval.includes('day') || interval.includes('days') || interval.includes('mon')){
            var year = begin.getFullYear()
            var month = begin.getMonth()
            var day = begin.getDate()
            var hours = begin.getHours()
            var minutes = begin.getMinutes()
            var seconds = begin.getSeconds()

            begin = new Date(year, (month), day, (hours-1), (minutes), (seconds))    
                
            year = end.getFullYear()
            month = end.getMonth()
            day = end.getDate()
            hours = end.getHours()
            minutes = end.getMinutes()
            seconds = end.getSeconds()
            end = new Date(year, (month), day, (hours+1), (minutes), (seconds))

        } else {
            let split = interval.split(':')  
            if (split[0] < 1 && split[1] > 0) {
                var year = begin.getFullYear()
                var month = begin.getMonth()
                var day = begin.getDate()
                var hours = begin.getHours()
                var minutes = begin.getMinutes()
                var seconds = begin.getSeconds()
    
                begin = new Date(year, (month), day, (hours), (minutes-(parseInt(split[1]))), (seconds))    
                 
                year = end.getFullYear()
                month = end.getMonth()
                day = end.getDate()
                hours = end.getHours()
                minutes = end.getMinutes()
                seconds = end.getSeconds()
                end = new Date(year, (month), day, (hours), (minutes+(parseInt(split[1]))), (seconds))
            } else {
                var year = begin.getFullYear()
                var month = begin.getMonth()
                var day = begin.getDate()
                var hours = begin.getHours()
                var minutes = begin.getMinutes()
                var seconds = begin.getSeconds()
    
                begin = new Date(year, (month), day, (hours-1), (minutes), (seconds))    
                    
                year = end.getFullYear()
                month = end.getMonth()
                day = end.getDate()
                hours = end.getHours()
                minutes = end.getMinutes()
                seconds = end.getSeconds()
                end = new Date(year, (month), day, (hours+2), (minutes), (seconds))
            }         
        }       
        
        let fecha_inicio = begin.toISOString().substring(0, 16).replace('T', ' ')
        let fecha_termino = end.toISOString().substring(0, 16).replace('T', ' ')  
        var fetchListScreenshot = this.getFetchs(currentObjectiveId, beginTitle, endTitle, monitores, token)
        fetch(api_host+`/reporte/online/eventos/Reporte3Events/?user=${id_user}&key=${api_auth}&objetive=${currentObjectiveId}&datebegin=${fecha_inicio}&finaldate=${fecha_termino}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}`)
            .then( response => response.json())
            .then( myJson =>  {
                try {
                    fetchListScreenshot.then( value=>{
                        this.processData(myJson, beginTitle, endTitle, value, token, currentObjectiveId)   
                    })           
                } catch (error) {
                this.setState({
                    dataError: true,
                    data: null,
                    isLoading: false
                });
            }
        });
        
    }
    processData = (externalData, fecha_inicio, fecha_termino, value, token, currentObjectiveId) => {
        const dataEvents  = externalData;
        var cell = -Infinity
        var pages = -Infinity
        var monitorList = []
        Object(dataEvents).forEach(element=>{
            if(element.data_nodo.length > pages){
                pages = element.data_nodo.length
            }
            Object(element.data_nodo).forEach(element_nodo=>{
                if(element_nodo.length > pages){
                    cell = element_nodo.length
                }
            })
            
        })
        var getDataMonitor = getMonitorsList(currentObjectiveId, fecha_inicio, fecha_termino , token)
        getDataMonitor.then( valueMon =>{
            this.setState({
                externalData: dataEvents,
                totalCell: cell,
                pages: pages,
                dateBegin: fecha_inicio,
                dateEnd: fecha_termino,
                listScreenshot: value,
                nodes : valueMon
            })
        })    
        
    }
    togglePopover = (event) => {      
        this.setState({ isOpen: !this.state.isOpen,
                        target: event.currentTarget,
                        currentDate: event.currentTarget.id,
                        currentMonitor: event.currentTarget.value});
    };
    onCloseModal = () => {
        this.setState({ isOpen: false });
    };
    setOpen=( ele, tokenPicture, stepToken, dateBeginScreenshot, patternName)=>{
        this.setState({
            modalOpen : true,
            modalClose : false,
            tokenPicture : tokenPicture,
            stepToken : stepToken,
            nameStep : ele,
            dateBeginScreenshot: dateBeginScreenshot,
            pattern: patternName
        })
    }
    
    setOpenElements=(step, date,monitor, objective)=>{
        this.setState({
            dataElements:{step, date, monitor, objective},
            modalOpenEle: true,
            modalCloseEle : false,
        })
    } 

    createCell(arrayMap, total, id, target, currentDate, currentMonitor, monitor_id, classes){
        const data_nodo = [...arrayMap]
        const {dateBegin, dateEnd, listScreenshot, nodes, pasos_criticos} = this.state
        var foundNodeName = "" 
        var critic_step = 0
        if (currentMonitor && currentMonitor !== null && currentMonitor !== undefined){
            foundNodeName = nodes.find(node => parseInt(node.monitor) === parseInt(currentMonitor))?.nodo ?? '';
            if (pasos_criticos && Object.keys(pasos_criticos).length > 0) {
                const ordenes = pasos_criticos[currentMonitor.toString()];
                if (ordenes) {
                    critic_step = ordenes[0]
                } else {
                    critic_step = pasos_criticos[""][0]
                }
            }
        }
        let codesOk = [0,9,14,17,30,200,204,301,304,307,602,1000]
        let codesOkString = ['0','9','14','17','30','200','204','301','304','307','602','1000']
        let token = sessionStorage.getItem('key')
        var cells=[]
        var screenshots = []
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        var steps = {}
        Object(data_nodo).forEach(element=>{
            let up = 0
            let down = 0
            let noMON = 0
            Object(element.pasos).forEach(({estado, patrones})=>{
                if ((estado != null || estado === 0) && estado.toString().includes(",")){
                    var split = estado.split(",")
                    let upPatterns = 0
                    let downPatterns = 0
                    Object(split).forEach(status=>{
                        if(codesOkString.includes(status)){
                            upPatterns = upPatterns + 1
                        }else{
                            downPatterns = downPatterns + 1
                        }  
                    })
                    if (downPatterns > 0) {
                        down = down + 1
                    } else {
                        up = up + 1
                    }
                } else if(estado == null){
                    let upPatterns = 0
                    let downPatterns = 0
                    let noMonPatterns = 0
                    Object(patrones).forEach(({estado})=>{
                        if(codesOk.includes(estado) || codesOkString.includes(estado)){
                            upPatterns = upPatterns + 1
                        }else if(estado === 'sin monitoreo'){
                            noMonPatterns = noMonPatterns + 1
                        }else{
                            downPatterns = downPatterns + 1
                        }
                    })
                    if (downPatterns > 0) {
                        down = down + 1
                    } else if (upPatterns > 0){
                        up = up + 1
                    } else if (noMonPatterns > 0){
                        noMON = noMON + 1
                    }
                }else {
                    if(codesOk.includes(parseInt(estado))){
                        up = up + 1
                    }else if(estado === 'sin monitoreo'){
                        noMON = noMON + 1
                    }else{
                        down = down + 1
                    }
                }
            })
            let status = 0
            if(noMON >= 1){
                status = 'sin monitoreo'
            }else if(down >= 1){
                status = 'downtime'
            }else{
                status = "uptime"
            }
            cells.push({"elementos": element, "estado": status})
        })
        let listFilteredScreenshot = []
        listScreenshot.forEach( monitor  =>{ 
            if (monitor.length > 0){
                monitor.forEach( registro => {
                    if (parseInt(registro.monitor_id) == monitor_id){
                        listFilteredScreenshot.push(registro)
                    }
                })
            }
        })
        return (
            <div>
                {cells.map((elements, id) => {
                    let listTokenDateFinal = [];
                    let listTokenFinal = [];
                    let disableButton = true;
                    let eventBegin = new Date(elements.elementos.desde);
                    let eventEnd = new Date(elements.elementos.hasta);
                
                    if (listFilteredScreenshot.length > 0) {
                        listFilteredScreenshot.forEach(screen => {
                        let screenDate = new Date(screen.fecha_creacion.replace('T', ' '));
                        if (eventBegin <= screenDate && screenDate < eventEnd) {
                            listTokenFinal.push(screen.tokens);
                            listTokenDateFinal.push(screen.fecha_creacion.replace('T', ' '));
                        }
                        });
                    }
                    const steps = [];
                    const colorEvent = elements.estado === "sin monitoreo" ? '#A9A9A9' :
                                 elements.estado === "downtime" ? '#C2272D' : '#41B900';
                    if (target && elements.elementos.desde === currentDate && parseInt(currentMonitor) === monitor_id) {
                        
                        elements.elementos.pasos.forEach((step, key) => {
                            let patternName = '';
                            var patterns = []
                            var status = 0
                            if (typeof(step.patrones) !== "undefined") {
                                step.patrones.forEach(patron => {
                                    patternName = patron.patron;
                                    var new_step = (
                                        <TableCell style={{borderBottom: 'none'}}>
                                            <Typography style={{height: "50px", paddingLeft: '30px', textAlign: 'center'}}>
                                            <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{t('events-objective-table-light.tooltip.status', {status: t('objective.status.no-monitoring')})+'\n'+t('events-objective-table-light.tooltip.pattern', {pattern: patternName})}</div>} placement="left">
                                                    <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO, zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                </Tooltip>
                                            </Typography>
                                        </TableCell>
                                    );
                                    if (patron.estado.toString() in lista_estados){
                                        if (patron.monitor_id){
                                            if (parseInt(patron.monitor_id) === parseInt(currentMonitor)) {
                                                var titleStatus = t('events-objective-table-light.tooltip.status', {status: t(`codes.${patron.estado}.name`)})
                                                var titlePattern = t('events-objective-table-light.tooltip.pattern', {pattern: patternName})
                                                var titleMon = ''
                                                if (patron.monitor_id)
                                                    var titleMon = t('events-objective-table-light.tooltip.mon', {mon: foundNodeName})
                                                var icon = lista_estados[patron.estado].icono
                                                new_step = (
                                                    <TableCell style={{borderBottom: 'none', textAlign: 'center'}}>
                                                        <Typography style={{height: "50px", textAlign: 'center'}}>
                                                            <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{titleStatus+'\n'+titlePattern+'\n'+titleMon}</div>} placement="left">    
                                                                <i style={{...icons.sprite, ...icons[icon], zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                            </Tooltip>
                                                        </Typography>
                                                    </TableCell>
                                                );
                                            } else {
                                                new_step = null
                                            }
                                        } else { 
                                            var titleStatus = t('events-objective-table-light.tooltip.status', {status: t(`codes.${patron.estado}.name`)})
                                            var titlePattern = t('events-objective-table-light.tooltip.pattern', {pattern: patternName})
                                            var icon = lista_estados[patron.estado].icono
                                            new_step = (
                                                <TableCell style={{borderBottom: 'none', textAlign: 'center'}}>
                                                    <Typography style={{height: "50px", textAlign: 'center'}}>
                                                        <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{titleStatus+'\n'+titlePattern}</div>} placement="left">    
                                                            <i style={{...icons.sprite, ...icons[icon], zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                        </Tooltip>
                                                    </Typography>
                                                </TableCell>
                                            );
                                        }       
                                    } else if (step.estado?.toString() === 'sin monitoreo') {
                                        new_step = (
                                            <TableCell style={{borderBottom: 'none'}}>
                                                <Typography style={{height: "50px", paddingLeft: '30px', textAlign: 'center'}}>
                                                <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{t('events-objective-table-light.tooltip.status', {status: t('objective.status.no-monitoring')})+'\n'+t('events-objective-table-light.tooltip.pattern', {pattern: patternName})}</div>} placement="left">
                                                        <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO, zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                    </Tooltip>
                                                </Typography>
                                            </TableCell>
                                        );
                                    } else {
                                        new_step = (
                                            <TableCell style={{borderBottom: 'none', textAlign: 'center'}}>
                                                <Typography style={{height: "50px", textAlign: 'center'}}>
                                                    <Tooltip title={t('events-objective-table-light.tooltip.error')} placement="left">
                                                        <i style={{...icons.sprite, ...icons.spriteSIN_NOMBRE, zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                    </Tooltip>
                                                </Typography>
                                            </TableCell>
                                        
                                        );
                                    }
                                    status = patron.estado
                                    patterns.push(new_step);
                                });
                            } else {
                                let new_step = (
                                    <TableCell style={{borderBottom: 'none'}}>
                                        <Typography style={{height: "50px", paddingLeft: '30px', textAlign: 'center'}}>
                                        <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{t('events-objective-table-light.tooltip.status', {status: t('objective.status.no-monitoring')})+'\n'}</div>} placement="left">
                                                <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO, zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                            </Tooltip>
                                        </Typography>
                                    </TableCell>
                                );
                                if (step.estado.toString() in lista_estados){
                                    var titleStatus = "Estado: "+lista_estados[step.estado].nombre
                                    var icon = lista_estados[step.estado].icono
                                    new_step = (
                                        <TableCell style={{borderBottom: 'none', textAlign: 'center'}}>
                                            <Typography style={{height: "50px", textAlign: 'center'}}>
                                                <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{titleStatus+'\n'}</div>} placement="left">    
                                                    <i style={{...icons.sprite, ...icons[icon], zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                </Tooltip>
                                            </Typography>
                                        </TableCell>
                                    );
                                } else if (step.estado.toString() === 'sin monitoreo') {
                                    new_step = (
                                        <TableCell style={{borderBottom: 'none'}}>
                                            <Typography style={{height: "50px", paddingLeft: '30px', textAlign: 'center'}}>
                                            <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{t('events-objective-table-light.tooltip.status', {status: t('objective.status.no-monitoring')})+'\n'}</div>} placement="left">
                                                    <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO, zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                </Tooltip>
                                            </Typography>
                                        </TableCell>
                                    );
                                } else {
                                    new_step = (
                                        <TableCell style={{borderBottom: 'none', textAlign: 'center'}}>
                                            <Typography style={{height: "50px", textAlign: 'center'}}>
                                                <Tooltip title={t('events-objective-table-light.tooltip.error')} placement="left">
                                                    <i style={{...icons.sprite, ...icons.spriteSIN_NOMBRE, zoom: "normal", scale: "0.1", transform: "none", transformOrigin: 'center 0px'}}/>
                                                </Tooltip>
                                            </Typography>
                                        </TableCell>
                                    
                                    );
                                }
                                status = step.estado
                                patterns.push(new_step);
                            }
                            let token = 'NULL';
                            let date = null;
                            listTokenFinal.forEach((elements, index) => {   
                                if (elements[parseInt(step.id)] !== 'NULL' && typeof(elements[parseInt(step.id)]) !== 'undefined') {
                                    token = elements[parseInt(step.id)];
                                    date = listTokenDateFinal[index];
                                }else{
                                    if (typeof(elements[parseInt(step.id)]) == 'undefined' && !codesOk.includes(status)){
                                        token = elements[parseInt(critic_step)];
                                        date = listTokenDateFinal[critic_step];
                                    }
                                }
                            });
                    
                            const panorama = token === 'NULL' || typeof(token) === 'undefined' ? 
                                            <div /> : 
                                                <Button onClick={() => this.setOpen(step.nombre_paso, token, parseInt(step.id), date, patternName)}>
                                                    <ImageOutlinedIcon />
                                                </Button>;
                    
                            const stepName = (
                                <Table>
                                    <TableRow>
                                        <TableCell style={{borderBottom: 'none'}}>
                                        <Typography>
                                            <Grid
                                            item
                                            xs={6}
                                            sm={6}
                                            md={6}
                                            xl={6}
                                            style={{textAlign: 'center', justifyContent: 'center', alignItems: 'center', display: 'flex', margin: 'auto'}}
                                            >
                                            {step.nombre_paso}
                                            </Grid>
                                        </Typography>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                            );
                            let new_step_final = (
                                <TableRow>
                                    <TableCell>{stepName}</TableCell>
                                    <TableCell>
                                        {patterns.map(pattern=>(
                                            <div>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    sm={6}
                                                    md={6}
                                                    xl={6}
                                                    style={{textAlign: 'center', justifyContent: 'center',aligItems: 'center',display: 'flex',margin:'auto'}}
                                                >
                                                    {pattern}
                                                </Grid>
                                            </div>
                                        ))}
                                    </TableCell>
                                    <TableCell style={{textAlign: 'center'}}>
                                        {panorama}
                                    </TableCell>
                                </TableRow>
                            );
                            steps.push(new_step_final);
                        });
                    }

                    if (new Date(elements.elementos.desde) < new Date(dateEnd) && new Date(dateBegin) < new Date(elements.elementos.hasta)) {
                        disableButton = false;
                    }
                
                    const duration = elements.elementos.duracion.replace('day', 'día');
                
                    return (
                        <React.Fragment>
                            <Button
                                id={elements.elementos.desde}
                                value={monitor_id}
                                disabled={disableButton}
                                style={{padding: "0px" }}
                                onClick={this.togglePopover}
                                key={id}
                                >
                                    <AtTimelineEvent
                                        color={colorEvent}
                                        title={elements.elementos.desde.substring(11, 19)}
                                        subtitle={elements.elementos.desde.substring(0, 10) + '\n(' + duration + ')'}
                                        titleProps={{textAlign: 'center'}}
                                        subtitleProps={{whiteSpace: 'pre-line', textAlign: 'center'}}
                                                    />
                            </Button>          
                            {steps.length > 0 && (
                                <Popover
                                anchorEl={target}
                                open={this.state.isOpen}
                                onClose={this.onCloseModal}
                                target={elements.elementos.desde + '-' + id}
                                anchorOrigin={{
                                    vertical: 'center',
                                    horizontal: 'center'
                                }}
                                transformOrigin={{
                                    vertical: 'center',
                                    horizontal: 'center'
                                }}
                                >
                                <Card>
                                    <CardContent style={{padding: 0}}>
                                    <Table size='small' className='table__cell--small-padding'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell colSpan={3} style={{ textAlign: 'center' }}>
                                                    {t('events-objective-table-light.table.header')}
                                                    <div style={{ textAlign: "center", marginTop: 5, display: "flex", justifyContent: "center" }}>
                                                        {currentDate.substring(11, 19)+' '}
                                                        {currentDate.substring(0, 10)}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                            <TableCell style={{ textAlign: "center" }}>
                                                {t('events-objective-table-light.table.steps')}
                                            </TableCell>
                                            <TableCell style={{ textAlign: "center" }}>
                                                {t('events-objective-table-light.table.status')}
                                            </TableCell>
                                            <TableCell style={{ textAlign: "center" }}>
                                                {t('events-objective-table-light.table.screenshot')}
                                            </TableCell>
                                            </TableRow>
                                            {steps}
                                        </TableBody>                        
                                    </Table>
                                </CardContent>
                            </Card>
                                </Popover>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        );
          
    }
    

    createRow(arrayMap, pag, target, currentDate, currentMonitor, classes){
        const {cellTotals, graph, dateBegin, dateEnd} = this.state           
        var isShowForNode = false
        var isDataForNode = true 
        var data_nodo_empty = []
        if (graph !== 'Consolidado') {
            isShowForNode = true
            const even = (element) => element.nombre_nodo === graph;
            if (!arrayMap.some(even)){
                var duration = (moment(dateEnd)-moment(dateBegin)) - 1
                duration = new Date(duration).toISOString().substr(11, 8)
                var array = {'hasta':dateEnd, 'desde': dateBegin, 'duracion':duration, pasos:[{'nombre': 'paso1', 'estado': 'sin monitoreo'}]}
                isDataForNode = false
                data_nodo_empty.push(array)
            }  
        }
        return (<>
                    {isDataForNode ? arrayMap.map(({id, nombre_nodo, data_nodo, monitor_id}) => { 
                        if(data_nodo[pag]){
                            if (isShowForNode) {
                                if (nombre_nodo === graph) {
                                    return  <TableRow id={id} style={{height: 20 ,width:"800px", borderBottom: "1px solid #8a8a8a"}}>
                                                <TableCell style={{fontSize:"14px", borderBottom: "none", padding:"0px", textAlign:"center", minWidth: 200, maxWidth: 200}} component="th" scope="row">
                                                    <Typography style={{fontSize: "18px", marginRight: 5}} variant="h4">{nombre_nodo}</Typography>
                                                </TableCell>
                                                <TableCell style={{fontSize:"14px", borderBottom: "none", padding:"0px", display:'flex'}}>
                                                        {this.createCell(data_nodo[pag], cellTotals, id, target, currentDate, currentMonitor, monitor_id, classes)} 
                                                </TableCell>
                                            </TableRow>
                                }                                
                            } else {
                                return  <TableRow id={id} style={{height: 20 ,width:"800px", borderBottom: "1px solid #8a8a8a"}}>
                                            <TableCell style={{fontSize:"14px", borderBottom: "none", padding:"0px", textAlign:"center", minWidth: 200, maxWidth: 200}} component="th" scope="row">
                                                <Typography style={{fontSize: "18px", marginRight: 5}} variant="h4">{nombre_nodo}</Typography>
                                            </TableCell>
                                            <TableCell style={{fontSize:"14px", borderBottom: "none" , padding:"0px", display:'flex'}}>
                                                {this.createCell(data_nodo[pag], cellTotals, id, target, currentDate, currentMonitor, monitor_id, classes)}                                                
                                            </TableCell>
                                        </TableRow>
                            }                            
                        }
                    })
                    : <TableRow id={0} style={{height: 20 ,width:"800px", borderBottom: "1px solid #8a8a8a"}}>
                        <TableCell style={{fontSize:"14px", borderBottom: "none", padding:"0px", textAlign:"center", minWidth: 200, maxWidth: 200}} component="th" scope="row"> 
                            <Typography style={{fontSize: "18px", marginRight: 5}} variant="h4">{graph}</Typography>
                        </TableCell>
                        <TableCell style={{fontSize:"14px", borderBottom: "none", padding:"0px"}}>                                                    
                                {this.createCell(data_nodo_empty, cellTotals, 0, target, currentDate, currentMonitor, 0, classes)} 
                        </TableCell>
                    </TableRow>}
                </>)
    }

    handleChangePage = (e, page)=>{
        this.setState({
            page : page
        })
    }

    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true
        })
    }

    setCloseModalEle=()=>{
        this.setState({
            modalOpenEle : false,
            modalCloseEle : true
        })
    }

    handleClose = event => {

        /*if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })*/
        this.props.onClose()
    };
    
    getElement=()=>{
        const {dataElements} =this.state
        if(typeof(dataElements)!=="undefined"){
            return <Elements objective={dataElements.objective} steps={dataElements.step} date={dataElements.date} 
                node={dataElements.monitor} onClose={this.setCloseModal}/>
        }else{
            return (null)
        }
        {/*<Elements objective={dataElements.objective} steps={dataElements.step} date={dataElements.date} 
    node={dataElements.monitor} onClose={this.setCloseModal}/>*/}
        
    }

    render() {
        const {pages, page, target, currentDate, currentMonitor, externalData, dataError, 
            dateBegin, dateEnd, modalOpen, modalOpenEle, dataElements, graph} = this.state
        
        const {classes, className, match } = this.props;
        
        let dataMaintenance = {'objetivo': match.params.objetivo_id ? match.params : {objetivo_id: this.state.currentObjectiveId}, 'dateBegin': dateBegin,'dateEnd': dateEnd}
        const rootClassName = classNames(classes.root, className);
        let admin = sessionStorage.getItem('admin')
        if (externalData !== null && !dataError )  {
            const row = this.createRow(externalData, page, target, currentDate, currentMonitor, classes)
            if(pages > 1){
                var PaginationTableValidation =  <TablePagination
                    rowsPerPageOptions={[5]}
                    component="div"
                    count={6*pages}
                    rowsPerPage={6}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'previous page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'next page',
                    }}
                    onChangePage={this.handleChangePage}
                    labelDisplayedRows={({ from, to, count }) => {
                            return `${from} - ${to} de ${count}`
                        }
                    }
                    />
            }
            const t = (this.props && this.props.t) ? this.props.t : (s => s)
            return(                
                <>
                    <DialogTitle /*className={classes.header}*/>     
                    <Box style={{display: 'flex', justifyContent: 'space-between', alignItems: 'start'}}>
                        <Box>
                            <Typography variant='h4' className='card__text--dark-color'>{match.params.nombre_objetivo}</Typography>
                            <Typography variant='caption'>{t('text.from')+' '+dateBegin+' '+t('text.to2')+' '+dateEnd}</Typography>
                        </Box>
                        {graph === 'Consolidado' ?
                             <Box style={{display: 'flex', justifyContent: 'space-between', alignItems: 'start'}}>
                                <Box>
                                    <Link to={{pathname: "/Maintenance", query: { tab: 2, dataMaintenance: dataMaintenance }, search: getQueryParams()}}>
                                        <Tooltip title={t('events-objective-table-light.tooltip.maintenance', {dateBegin, dateEnd})}>
                                            <Button style={{backgroundColor: '#FF8B32', color:'white'}} variant="outlined" size="small">
                                                <Typography variant="button"> {t('events-objective-table-light.button.schedule-maintenance')} </Typography>
                                            </Button>
                                        </Tooltip>
                                    </Link>
                                </Box>
                                {admin ? 
                                <Box style={{paddingLeft: '10px'}}>
                                    <Link to={{pathname: "/Maintenance", query: { tab: 3, dataMaintenance: dataMaintenance }, search: getQueryParams()}}>
                                        <Tooltip title={t('events-objective-table-light.tooltip.marked-period', {dateBegin, dateEnd})}>
                                            <Button style={{backgroundColor: '#FF8B32', color:'white'}} variant="outlined" size="small">
                                                <Typography variant="button"> {t('events-objective-table-light.button.schedule-atentus-maintenance')} </Typography>
                                            </Button>
                                        </Tooltip>
                                    </Link>
                                </Box>
                                :null}
                            </Box>
                        :null}
                        
                        <IconButton key="close" aria-label="close" onClick={this.handleClose}><CloseIcon/></IconButton>
                    </Box>                  
                    </DialogTitle>
                    
                    <DialogContent className='timeline-content' style={{maxHeight: '100%', overflowX: 'auto', overflowY: 'auto'}}>
                        <Box>
                        <Table>
                            {row}
                            {PaginationTableValidation}
                        </Table>
                        </Box>
                    </DialogContent>
                    <Dialog
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={modalOpenEle}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 100,
                        }}               
                    >
                        <Fade in={modalOpenEle}>
                            {this.getElement()}
                        </Fade>
                    </Dialog>
                    <Dialog
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={modalOpen}
                        onClose={this.setCloseModal}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 100,
                        }}               
                    >
                        <Fade in={modalOpen}>
                            <Screenshot data = {this.state} onClose={this.setCloseModal}/>
                        </Fade>
                    </Dialog>
                </>
            )
        }else{
            return (<AtCircularProgress />)
        }
    }
}

export default 
compose(
  withRouter,
  withStyles(styles),
  withTranslation()
)(EventsTable);